<template>
    <ValidationObserver ref="contactform">
        <div v-if="contact_data">
            <div class="row">
                <div class="col-8">
                    <ValidationProvider vid="name" name="Namn" rules="required" v-slot="{ errors }">
                        <div class="form-group">
                            <label>Namn <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" v-model="contact_data.name" v-bind:class="{ 'border-danger':errors[0] }">
                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                        </div>
                    </ValidationProvider>
                </div>
                <div class="col-4">
                    <ValidationProvider vid="is_important" name="VIP" rules="" v-slot="{ errors }">
                        <div class="form-group" style="padding-top: 28px;">
                            <button type="button" class="btn btn-light" @click="contact_data.is_important = !contact_data.is_important">
                                <i v-bind:class="[ ( contact_data.is_important ? 'icon-star-full2 text-orange-400' : 'icon-star-empty3') ]"></i> VIP
                            </button>
                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                        </div>
                    </ValidationProvider>
                </div>
            </div>
            <div class="row">
                <div class="col-4">
                    <ValidationProvider vid="company_id" name="Företag" rules="" v-slot="{ errors }">
                        <div class="form-group">
                            <label>Företag</label>
                            <div class="input-group">
                                <v-select
                                    v-model="contact_data.company_id"
                                    :options="Object.values(companies)"
                                    placeholder="Välj företag"
                                    :reduce="opt => opt.id"
                                    label="text"
                                ></v-select>
                                <div class="input-group-append">
                                    <router-link :to="{ name:'crm.company', params: { id: contact_data.company_id }, query: { from: current_url } }" class="btn btn-light btn-icon" target="_blank"><i class="icon-office"></i></router-link>
                                </div>
                            </div>
                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                        </div>
                    </ValidationProvider>
                </div>
                <div class="col-4">
                    <ValidationProvider vid="work_title" name="Befattning" rules="" v-slot="{ errors }">
                        <div class="form-group">
                            <label>Befattning</label>
                            <input type="text" class="form-control" v-model="contact_data.work_title" v-bind:class="{ 'border-danger':errors[0] }">
                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                        </div>
                    </ValidationProvider>
                </div>
                <div class="col-4">
                    <ValidationProvider vid="department" name="Avdelning / Förvaltning" rules="" v-slot="{ errors }">
                        <div class="form-group">
                            <label>Avdelning / Förvaltning</label>
                            <input type="text" class="form-control" v-model="contact_data.department" v-bind:class="{ 'border-danger':errors[0] }">
                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                        </div>
                    </ValidationProvider>
                </div>
            </div>
            <div class="row">
                <div class="col-4">
                    <ValidationProvider vid="buys_for" name="Köper till" rules="" v-slot="{ errors }">
                        <div class="form-group">
                            <label>Köper till</label>
                            <input type="text" class="form-control" v-model="contact_data.buys_for" v-bind:class="{ 'border-danger':errors[0] }">
                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                        </div>
                    </ValidationProvider>
                </div>
                <div class="col-4">
                    <ValidationProvider vid="info_email" name="Offert / Info via email" rules="" v-slot="{ errors }">
                        <div class="form-group">
                            <label>Offert / Info via email</label>
                            <v-select
                                v-model="contact_data.info_email"
                                :options="select_info_email"
                                placeholder="Välj..."
                                :reduce="opt => opt.id"
                                label="text"
                            ></v-select>
                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                        </div>
                    </ValidationProvider>
                </div>
                <div class="col-4">
                    <ValidationProvider vid="notes" name="Noteringar" rules="" v-slot="{ errors }">
                        <div class="form-group">
                            <label>Noteringar</label>
                            <input type="text" class="form-control" v-model="contact_data.notes" v-bind:class="{ 'border-danger':errors[0] }">
                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                        </div>
                    </ValidationProvider>
                </div>
            </div>
            <div class="row">
                <div class="col-4">
                    <ValidationProvider vid="email" name="E-post" rules="" v-slot="{ errors }">
                        <div class="form-group">
                            <label>E-post</label>
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="contact_data.email" v-bind:class="{ 'border-danger':errors[0] }">
                                <div class="input-group-append">
                                    <a :href="'mailto:' + contact_data.email" class="btn btn-light btn-icon"><i class="icon-envelope"></i></a>
                                </div>
                            </div>
                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                        </div>
                    </ValidationProvider>
                </div>
                <div class="col-4">
                    <ValidationProvider vid="phone" name="Tel. nr." rules="" v-slot="{ errors }">
                        <div class="form-group">
                            <label>Tel. nr.</label>
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="contact_data.phone" v-bind:class="{ 'border-danger':errors[0] }">
                                <div class="input-group-append">
                                    <a :href="'tel:' + contact_data.phone" class="btn btn-light btn-icon"><i class="icon-phone2"></i></a>
                                </div>
                            </div>
                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                        </div>
                    </ValidationProvider>
                </div>
                <div class="col-4">
                    <ValidationProvider vid="mobile_phone" name="Mob. nr." rules="" v-slot="{ errors }">
                        <div class="form-group">
                            <label>Mob. nr.</label>
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="contact_data.mobile_phone" v-bind:class="{ 'border-danger':errors[0] }">
                                <div class="input-group-append">
                                    <a :href="'tel:' + contact_data.mobile_phone" class="btn btn-light btn-icon"><i class="icon-phone2"></i></a>
                                </div>
                            </div>
                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                        </div>
                    </ValidationProvider>
                </div>
            </div>
            <div class="text-muted">Senast uppdaterad {{ formatDateTime(contact_data.updated_at) }}<span v-if="contact_data.updated_by"> av {{ contact_data.updated_by.name }}</span></div>
        </div>
    </ValidationObserver>
</template>

<script>
import vSelect from 'vue-select';
import { formatDateTime } from '@services/Helpers';

export default {
    name: 'ContactForm',
    components: {
        vSelect,
    },
    props: {
        busy: {
            type: Boolean,
            default: false,
        },
        value: {
            type: Object,
            default() {
                return {};
            },
        },
        companies: {
            type: Object,
            default() {
                return {};
            },
        },
        strings: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    watch: {
        value(data) {
            this.contact_data = data;
        },
        contact_data: {
            deep: true,
            handler(val) {
                this.$emit('change', val);
            },
        },
    },
    data: () => ({
        contact_data: null,
    }),
    mounted() {
        this.contact_data = this.value;
    },
    methods: {
        formatDateTime,
        async validate() {
            return this.$refs.contactform.validate();
        },
        async setErrors(errors) {
            return this.$refs.contactform.setErrors(errors);
        },
    },
    computed: {
        select_info_email() {
            return this.strings[501] ?? [];
        },
        current_url() {
            const { id } = this.contact_data; // eslint-disable-line no-unused-vars
            const currentState = history.state; // eslint-disable-line no-restricted-globals
            const urlParams = Object.keys(currentState).map((key) => `${key}=${encodeURIComponent(currentState[key])}`).join('&');
            return `${this.$route.fullPath}?${urlParams}`;
        },
    },
};
</script>

<style scoped>

</style>
